Ext.define('SA.controller.PerformImportController', {
    mixins: {
        observable: 'Ext.util.Observable'
    },

    constructor({data}) {
        this.data = data;

        this.mixins.observable.constructor.call(this);

        this.statusWindow = Ext.widget('import-status-window');

        this.request = SA.Ajax.request({
            xhr: true,
            method: 'import',
            resource: 'user/data',
            onChange: this.onRequestStateChange.bind(this),
            data
        });
    },

    destroy() {
        this.destroyStatusWindow();

        this.fireEvent('destroy');
    },

    destroyStatusWindow() {
        Ext.destroyMembers(this, 'statusWindow');
    },

    async onRequestStateChange(state) {
        var isUploading = !state.closed && state.progress < 100,
            isProcessing = !isUploading && !state.closed,
            success = state.result?.success,
            error = state.result?.error;

        if (isUploading) {
            this.statusWindow.setUploadProgress(state.progress);
        }
        else if (isProcessing) {
            this.statusWindow.setProcessing();
        }
        else if (success) {
            this.onSuccess();
        }
        else if (error.isSessionError()) {
            error.flagUnexpected();
            this.destroy();
        }
        else if (error.hasType('FilesWithUnknownLocationSeriesException')) {
            this.onUnknownLocationsError(error.getData());
        }
        else if (error.isTimeoutError()) {
            this.onTimeout();
        }
        else {
            this.onUnknownPresumedImportsError();
        }
    },

    async onSuccess() {
        await SA.data.UserImports.refresh().then(() => SA.Sidebar.refreshDataPanel());

        Ext.widget('import-success-window', {
            importCountry: this.data.country,
            isImportCountryCurrentCountry: this.data.country === SA.AppController.getCurrentCountryCode(),
            listeners: {destroy: () => this.destroy()}
        });

        this.destroyStatusWindow();
    },

    onTimeout() {
        SA.ImportRequestErrorWindow.get({strongText: 'Sorry, your import may not have completed because of a timeout.'});

        this.destroyStatusWindow();
    },

    onUnknownLocationsError(errorRecords) {
        var popup = Ext.widget('locations-not-found-window', {
            files: errorRecords.map(record => ({
                ...record,
                fileName: this.data.files[record.fileIndex].fileName
            }))
        });

        popup.on('destroy', this.destroy, this);

        this.destroyStatusWindow();
    },

    onUnknownPresumedImportsError() {
        SA.ImportRequestErrorWindow.get({strongText: 'Sorry, your import may not have completed because of an unexpected error.'});

        this.destroyStatusWindow();
    }
});
